import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './help_account.css';

export default class help_account extends Component {
  render() {
    return (
      <div>
        
      </div>
    )
  }
}
